import React, { FC, useState, useLayoutEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../state/index';
import { AppState, UserRole } from '../../models';
import './AppSetup.css';

interface AppSetupProps {
  className?: string
  selectedIndex?: number
}

export function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const AppSetup: FC<AppSetupProps> = ({className, selectedIndex = -1}: AppSetupProps) => {

  const dispatch = useDispatch()

  const { updateRole, updateAppState } = bindActionCreators(actionCreators, dispatch)

  const dropdownButton = useRef<HTMLDivElement>(null)
  const dropdownContainer = useRef<HTMLDivElement>(null)
  const itemsContainer = useRef<HTMLDivElement>(null)
  const [item, setItem] = useState(UserRole.NotSet)
  const [show, setShow] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [width, height] = useWindowSize()
  const roles = Object.values(UserRole).sort().filter((r) => r !== UserRole.NotSet)
  

  useLayoutEffect(() => {
    if (dropdownButton.current !== null && dropdownContainer.current !== null && itemsContainer.current !== null) {
      const padding = 1
      var newTop = dropdownButton.current.offsetTop + dropdownButton.current.clientHeight + padding
      const newLeft = dropdownButton.current.offsetLeft + (dropdownButton.current.clientWidth / 2.0) - (dropdownContainer.current.clientWidth / 2.0)
      dropdownContainer.current.style.left = `${newLeft - padding}px`
      dropdownContainer.current.style.width = `${dropdownButton.current.clientWidth}px`
      if (newTop > (height / 2.0)) {
        // put the drop down above
        newTop = 20
        const heightOfPopover = dropdownButton.current.offsetTop - (padding * 4)
        dropdownContainer.current.style.top = `${newTop}px`
        dropdownContainer.current.style.maxHeight = `${heightOfPopover}px`
        itemsContainer.current.style.maxHeight = `${heightOfPopover - 60}px`
      } else {
        dropdownContainer.current.style.top = `${newTop}px`
        dropdownContainer.current.style.maxHeight = `${height - newTop - 80}px`
        itemsContainer.current.style.maxHeight = `${height - newTop - 140}px`
      }
    }
  })

  function updateIndex(index: number) {
    setItem(roles[index])
    selectedIndex = index
  }

  const dropDownListNodes = roles.map((listItem, index) => {
      return (
        <div 
          key={index}
          className={`list-item${index === selectedIndex ? ' selected' : ''}`} 
          onClick={() => {
            updateIndex(index)
            setShow(false)
          }}
        >
          {`${listItem}`}
        </div>
      )
  })

  function handleSubmit() {
    updateAppState(AppState.Transition)
    updateRole(item)
  }

  return (
    <div className={`AppSetup${className !== null ? ` ${className}` : ''}`}>
      <div className="title">AITA™ Learning</div>
      <div className="description">Overview of the AITA™ Learning App</div>
      <p>Take learning to the next level with this interactive training application designed to give you all the tools you need to conquer the ins and outs of the AITA™ system. Participate at your own speed and identify critical skills to work efficiently with the Kiosk, Smart Shelves, Mobile Hub, Suture Scanning, and Order Management. Use this learning application as an instruction guide and reference tool to help you determine the AITA™ keys to success.</p>
      <div ref={dropdownButton} className="roles-drop-down" onClick={() => { setShow(!show) } }>
        <span style={{flex: 2, textAlign: 'left'}}>{item !== UserRole.NotSet ? item : 'What is your Role?' }</span><span className={`carrot${show ? ' show' : ''}`}></span>
        <div className={`drop-down ${show ? 'displayed' : 'hidden'}`}>
          <div className={`backdrop${show ? '' : ' hidden'}`} onClick={() => {
              setShow(false)
            }
          }></div>
          
          <div ref={dropdownContainer} className="items-container" style={{ minHeight: '35px'}}>
            <div ref={itemsContainer} className="actual-items">
              {dropDownListNodes}
            </div>
          </div>
        </div>
      </div>
      <div className={`confirm-button${item === UserRole.NotSet ? ' disabled' : ''}`} onClick={handleSubmit}>Confirm</div>
      
    </div>
  )
};

export default AppSetup;
